import { Box, Flex, Grid, Heading, Text } from '@chakra-ui/react'
import React from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { useTranslation } from 'react-i18next'
import { motion, scale } from 'framer-motion'


const DashboradViewSection = () => {

    const cardColor = useColorModeValue('white', 'gray.900')

    // Image de fond générique (à remplacer par votre propre image de collines vertes)

    // Styles communs partagés par toutes les tuiles
    const cardStyles = {
        // backgroundImage: bgImage,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "24px", // Arrondi par défaut pour toutes les cartes
        position: "relative",
        aspectRatio: "4/3", // Pour garder des proportions rectangulaires similaires à l'image
    }

    const MotionBox = motion.create(Box)
    const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
        staggerChildren: 0.1, // Délai entre chaque item
        },
    },
    };

    const itemVariants = {
    hidden: { y: 20, opacity: 0, rotate: 10 },
    visible: { y: 0, opacity: 1, rotate: 0 },
    };


    const ArrayOfImage = [
        {
            image: `url(${'https://i.pinimg.com/736x/11/3d/50/113d50542dcdd79170fc66e3c2c3e6bd.jpg'})`,
            cardStyles: cardStyles,
        },
        {
            image: `url(${'https://setalmaa.com/wp-content/uploads/Belle-femme-africaine.jpeg'})`,
            cardStyles: cardStyles,
        },
        {
            image: `url(${'https://i.pinimg.com/236x/16/af/56/16af5616895ccce0165462566994f859.jpg'})`,
            cardStyles: cardStyles,
        },
        {
            image: `url(${'https://us.123rf.com/450wm/iordani/iordani2012/iordani201201804/161311729-jolie-jeune-femme-afro-am%C3%A9ricaine-aux-cheveux-boucl%C3%A9s-posant-des-gestes-joyeux-sur-fond-marron.jpg?ver=6'})`,
            cardStyles: cardStyles,
        },
        {
            image: `url(${'https://yop.l-frii.com/wp-content/uploads/2024/08/Olivia-Yace-5e-Tiwa-Savage-3e.-voici-les-plus-belles-femmes-dAfrique-en-2024-1024x1024.jpg'})`,
            cardStyles: cardStyles,
        },
        {
            image: `url(${'https://us.123rf.com/450wm/neonshot/neonshot2303/neonshot230300017/204080185-charismatic-happy-natural-african-american-woman-with-afro-hairstyle-dancing-and-laughing-out-loud.jpg?ver=6'})`,
            cardStyles: cardStyles,
        },
        {
            image: `url(${'https://www.newstoriesafrica.com/wp-content/uploads/2023/01/nnaji.png'})`,
            cardStyles: cardStyles,
        },
        {
            image: `url(${'https://forbesafrique.com/wp-content/uploads/2023/03/Busola-Tejumola-Nigeria-M-1024x755.png'})`,
            cardStyles: cardStyles,
        },
        {
            image: `url(${'https://t4.ftcdn.net/jpg/02/02/25/47/360_F_202254776_1KoVzNGlBuvLXGZv3snqNERB5VoFmMYe.jpg'})`,
            cardStyles: cardStyles,
        },

    ]
    const {t} = useTranslation()

  return (
    <Flex
        px={{md: 'inherit', '2xl': "19%", base: 4}}
        py={{'2xl' :20, base: 10}}
        overflow={'hidden'}
        position={'relative'}
    >
        <Flex w={'full'} pt={20}>
            <Flex gap={{ base: 8, md: 'inherit' }} flexDir={{ base: 'column', md: 'row' }} w={'full'}> 

                <MotionBox 
                initial="hidden"
                whileInView={"visible"}
                variants={containerVariants} w={'full'} >
                    <Grid 
                        gridTemplateColumns={{ base: "repeat(3, 1fr)", md: "repeat(3, 200px)" }} 
                        gap={{ base: 2, md: 4 }} 
                    >

                        
                        {/* --- LIGNE 1 --- */}
                        {/* Carte 1 : Coin inférieur gauche très arrondi */}
                        <MotionBox {...cardStyles} variants={itemVariants} key={1} backgroundImage={ArrayOfImage[0].image} borderBottomLeftRadius="100px" />

                        {/* Carte 2 : Contient le texte des fichiers */}
                        <MotionBox {...cardStyles} variants={itemVariants} key={2} backgroundImage={ArrayOfImage[1].image}>

                            <Box zIndex={2} boxShadow={'md'} bgColor={'white'} w={'max-content'} pos={'absolute'} left={-28} top={-20} rounded={'full'}>
                                <Text fontFamily={'Outfit'} p={1} px={3} color={'gray.800'}> {t('vectorAssetTextServiceOne')} 😍</Text>
                            </Box>

                            <Box zIndex={1} w={'120px'} rotate={'-130deg'} position={'absolute'} top={-12}>
                                <svg viewBox="0 0 724 345" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.5209 281.79C27.2783 288.678 30.2408 304.633 38.6766 306.139C50.0673 308.171 49.279 295.778 48.8317 287.826C47.9523 272.187 36.5981 250.071 40.5486 235.466C134.872 310.547 248.95 349.292 369.43 344.484C489.264 339.702 620.711 295.444 695.685 196.3C732.381 147.774 755.651 89.4905 748.379 27.4248C747.756 22.0991 745.889 -4.36882 736.193 0.623444C731.138 3.22577 733.866 37.1863 733.41 43.3229C731.043 75.2243 723.276 104.891 709.223 133.514C661.336 231.044 555.521 289.206 453.044 309.476C385.159 322.903 312.744 321.351 244.916 306.028C209.905 298.119 174.903 286.678 142.758 270.415C115.645 256.698 70.5214 235.185 53.4016 208.821C79.9561 202.578 113.57 222.152 141.003 219.852C155.536 218.635 167.818 206.339 152.928 195.213C140.856 186.193 114.308 188.061 99.8248 186.427C83.6642 184.604 67.5371 183.317 51.2821 183.018C39.3582 182.798 13.8605 177.346 4.75877 186.067C-11.3354 201.488 18.0215 263.903 24.5209 281.79C21.8093 274.327 27.4037 288.992 24.5209 281.79Z" fill="#efefefef"/>
                                    <path d="M24.5209 281.79C27.2783 288.678 30.2408 304.633 38.6766 306.139C50.0673 308.171 49.279 295.778 48.8317 287.826C47.9523 272.187 36.5981 250.071 40.5486 235.466C134.872 310.547 248.95 349.292 369.43 344.484C489.264 339.702 620.711 295.444 695.685 196.3C732.381 147.774 755.651 89.4905 748.379 27.4248C747.756 22.0991 745.889 -4.36882 736.193 0.623444C731.138 3.22577 733.866 37.1863 733.41 43.3229C731.043 75.2243 723.276 104.891 709.223 133.514C661.336 231.044 555.521 289.206 453.044 309.476C385.159 322.903 312.744 321.351 244.916 306.028C209.905 298.119 174.903 286.678 142.758 270.415C115.645 256.698 70.5214 235.185 53.4016 208.821C79.9561 202.578 113.57 222.152 141.003 219.852C155.536 218.635 167.818 206.339 152.928 195.213C140.856 186.193 114.308 188.061 99.8248 186.427C83.6642 184.604 67.5371 183.317 51.2821 183.018C39.3582 182.798 13.8605 177.346 4.75877 186.067C-11.3354 201.488 18.0215 263.903 24.5209 281.79C21.8093 274.327 27.4037 288.992 24.5209 281.79Z" fill="#c8c8c8ff"/>
                                </svg>
                            </Box>
                        </MotionBox>

                        {/* Carte 3 : Normale */}
                        <MotionBox {...cardStyles} variants={itemVariants} key={3} backgroundImage={ArrayOfImage[2].image}/>


                        {/* --- LIGNE 2 --- */}
                        {/* Carte 4 : Normale */}
                        <MotionBox {...cardStyles} variants={itemVariants} key={4} backgroundImage={ArrayOfImage[3].image}>

                        </MotionBox>

                        {/* Carte 5 : Centre (Contient l'arbre dans votre image) */}
                        <MotionBox {...cardStyles} variants={itemVariants} key={5} backgroundImage={ArrayOfImage[4].image}>

                            <Box 
                            position={'absolute'} 
                            rounded={20} 
                            zIndex={10}
                            h={{md:'150px', base: '100px'}} 
                            w={{md: '200px', base: '140px'}}
                            left={{md: '-8.2em', base: '-6.5em'}}
                            display={'flex'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            flexDir={'column'}
                            top={16}
                            p={{md: 8, base: 4}}
                            // bottom={-20}
                            bg={cardColor} // Couleur de fond blanche avec transparence (entre 0.1 et 0.3 fonctionne bien)
                            backdropFilter="blur(5px)"    // L'effet de flou sur l'arrière-plan de cet élément
                            boxShadow="0 4px 30px rgba(0, 0, 0, 0.1)" // Une ombre subtile pour un effet 3D
                            >
                               <Heading lineHeight={1.1} textAlign={'center'}  p={2}  fontWeight={800} fontSize={{'2xl' :'3xl', base: 'lg'}} fontFamily={'Manrope'}>The best of all here</Heading> 
                               <Heading textAlign={'center'} mt={1} p={2}  fontWeight={800} fontSize={{'2xl' :'3xl', base: 'lg'}} fontFamily={'Manrope'}> </Heading> 
                            </Box>
                        </MotionBox>

                        {/* Carte 6 : Côté droit en demi-cercle */}
                        <MotionBox {...cardStyles} variants={itemVariants} key={6} borderRightRadius="999px" backgroundImage={ArrayOfImage[5].image} />


                        {/* --- LIGNE 3 --- */}
                        {/* Carte 7 : Profil de l'utilisateur */}
                        <MotionBox {...cardStyles} variants={itemVariants} key={7} backgroundImage={ArrayOfImage[6].image}>
                        
                        </MotionBox>

                        {/* Carte 8 : Normale */}
                        <MotionBox {...cardStyles} variants={itemVariants} key={8} backgroundImage={ArrayOfImage[7].image}/>

                        {/* Carte 9 : Contient le montant */}
                        <MotionBox {...cardStyles} variants={itemVariants} key={9} backgroundImage={ArrayOfImage[8].image}>
                            <Box zIndex={2} boxShadow={'md'} bgColor={'white'} w={'max-content'} pos={'absolute'} right={-40} top={-20} rounded={'full'}>
                                <Text fontFamily={'Outfit'} p={1} px={3} color={'gray.800'}>{t('vectorAsset2TextServiceOne')} ❤️‍🩹❤️‍🩹</Text>
                            </Box>

                            <Box zIndex={1} w={'120px'} transform={'scaleY(-1)'} rotate={'-40deg'} position={'absolute'} top={-12} right={-10}>
                                <svg viewBox="0 0 724 345" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.5209 281.79C27.2783 288.678 30.2408 304.633 38.6766 306.139C50.0673 308.171 49.279 295.778 48.8317 287.826C47.9523 272.187 36.5981 250.071 40.5486 235.466C134.872 310.547 248.95 349.292 369.43 344.484C489.264 339.702 620.711 295.444 695.685 196.3C732.381 147.774 755.651 89.4905 748.379 27.4248C747.756 22.0991 745.889 -4.36882 736.193 0.623444C731.138 3.22577 733.866 37.1863 733.41 43.3229C731.043 75.2243 723.276 104.891 709.223 133.514C661.336 231.044 555.521 289.206 453.044 309.476C385.159 322.903 312.744 321.351 244.916 306.028C209.905 298.119 174.903 286.678 142.758 270.415C115.645 256.698 70.5214 235.185 53.4016 208.821C79.9561 202.578 113.57 222.152 141.003 219.852C155.536 218.635 167.818 206.339 152.928 195.213C140.856 186.193 114.308 188.061 99.8248 186.427C83.6642 184.604 67.5371 183.317 51.2821 183.018C39.3582 182.798 13.8605 177.346 4.75877 186.067C-11.3354 201.488 18.0215 263.903 24.5209 281.79C21.8093 274.327 27.4037 288.992 24.5209 281.79Z" fill="#efefefef"/>
                                    <path d="M24.5209 281.79C27.2783 288.678 30.2408 304.633 38.6766 306.139C50.0673 308.171 49.279 295.778 48.8317 287.826C47.9523 272.187 36.5981 250.071 40.5486 235.466C134.872 310.547 248.95 349.292 369.43 344.484C489.264 339.702 620.711 295.444 695.685 196.3C732.381 147.774 755.651 89.4905 748.379 27.4248C747.756 22.0991 745.889 -4.36882 736.193 0.623444C731.138 3.22577 733.866 37.1863 733.41 43.3229C731.043 75.2243 723.276 104.891 709.223 133.514C661.336 231.044 555.521 289.206 453.044 309.476C385.159 322.903 312.744 321.351 244.916 306.028C209.905 298.119 174.903 286.678 142.758 270.415C115.645 256.698 70.5214 235.185 53.4016 208.821C79.9561 202.578 113.57 222.152 141.003 219.852C155.536 218.635 167.818 206.339 152.928 195.213C140.856 186.193 114.308 188.061 99.8248 186.427C83.6642 184.604 67.5371 183.317 51.2821 183.018C39.3582 182.798 13.8605 177.346 4.75877 186.067C-11.3354 201.488 18.0215 263.903 24.5209 281.79C21.8093 274.327 27.4037 288.992 24.5209 281.79Z" fill="#efefefef"/>
                                </svg>
                            </Box>
                        </MotionBox>
                    </Grid>
                </MotionBox>

                <Flex gap={12} flexDir={'column'} align={'end'} flexGrow={1} w={'full'}>
                    <Heading fontSize={{ md: '4xl', '2xl': '5xl', base: '2xl' }} textAlign={'right'} maxW={{md: '450px', base: '80%'}}  fontFamily={'Poppins'} letterSpacing={-1.5} lineHeight={1.1} >
                        {t('sectionTitleServiceOne')}
                    </Heading>

                    <Box maxW={'600px'}>
                       <Text textAlign={{md: 'right', base: 'justify'}}>
                            {t('sectionDescriptionServiceOne')}
                       </Text> 
                    </Box>
                </Flex>
            </Flex>
        </Flex>


    </Flex>
  )
}

export default DashboradViewSection